import { KMF_COVER_CATEGORIES } from '@om/redux/actions/kaMetlhaFuneralCover/types';
import {
    getCoverType,
    getMainMemberDetails,
    getEditQuoteDetails,
    getQuoteForm,
} from '@om/redux/selectors/kaMetlhaFuneralCover/quote';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    OmButton,
    OmEfpAddCoverDrawer,
    OmFormError,
    OmLoader,
    OmRadioButtonGroup,
    OmSideDrawer,
} from '@om/component-library-react';
import {
    addToQuote,
    setBenefitsOnPremimumValue,
    setBenefitsValue,
    setQuoteDetailsStateValue,
    setQuoteDetailsValue,
    setQuoteDrawerValue,
} from '@om/redux/actions/kaMetlhaFuneralCover/quote';
import { getActivePageIndex } from '@om/redux/selectors/kaMetlhaFuneralCover/routing';

const FormContent = () => {
    const dispatch = useDispatch();
    const { coverType, formFields, mainMember, editQuoteDetails, activePageIndex } = useSelector(
        createStructuredSelector({
            coverType: getCoverType,
            formFields: getQuoteForm,
            mainMember: getMainMemberDetails,
            editQuoteDetails: getEditQuoteDetails,
            activePageIndex:getActivePageIndex
        })
    );

    const { age } = mainMember ?? { age: null };
    const { benefitsDetails, benefitsDetailsOnPremium } = formFields;
    useEffect(() => {
        coverType === KMF_COVER_CATEGORIES.BENIFITS &&
            dispatch(setQuoteDetailsValue({ fieldType: 'age', value: age?.value }));
    }, [coverType]);
    const actionHandler = (fieldType, value, displayValue = null) => {
        dispatch(setQuoteDetailsValue({ fieldType, value, displayValue }));
    };

    return (
        <>
            <OmSideDrawer
                open={coverType === KMF_COVER_CATEGORIES.BENIFITS}
                onOnSideDrawerClosed={() => {
                    dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
                    dispatch(
                        setQuoteDetailsStateValue({
                            fieldType: 'editQuoteDetails',
                            value: { id: null, category: null },
                        })
                    );
                    // dispatch(setSideDrawerClosed());
                }}
            >
                <div slot="side-drawer-content">
                    <OmEfpAddCoverDrawer>
                        <div className="progressive-disclosure-form-wrapper">
                            <h5 className="no-top-margin no-bottom-margin medium">Would you like to add more benefits to your cover?</h5>

                            <span className="mobile-line-break">
                                <br />
                                <br />
                            </span>

                            <p className="inline-group">
                                <strong>
                                    Cash back* <br />
                                </strong>
                                <span className="mobile-line-break no-top-margin small">
                                    The Cashback benefit pays out 10% of all premiums paid every 5 years, if there was
                                    no claim paid on the policy.
                                </span>
                            </p>
                            <OmRadioButtonGroup
                                vertical="false"
                                groupName="retirement-for"
                                value={benefitsDetails?.value}
                                onOnSelection={(event) => actionHandler('benefitsDetails', event.detail)}
                            >
                                <ul>
                                    <li value={'Yes'}>Yes</li>
                                    <li value={'No'}>No</li>
                                </ul>
                            </OmRadioButtonGroup>
                            <div slot="hint-text">
                                <OmFormError message={benefitsDetails.error} />
                            </div>
                            <span className="mobile-line-break">
                                <br />
                                <br />
                            </span>
                            {/* {age?.value < 50 && (
                                <>
                                    <p className="inline-group">
                                        <strong>
                                            Premium paid up* <br />
                                        </strong>
                                        <p className="mobile-line-break no-top-margin small">
                                            Keeps the policy active when you reach the age of 60, with no additional
                                            premiums required for you and your direct family. This benefit does not
                                            include your parents and extended family members and needs to be active for
                                            at least 10 years.
                                        </p>
                                    </p>
                                    <OmRadioButtonGroup
                                        vertical="false"
                                        groupName="retirement"
                                        value={benefitsDetailsOnPremium?.value}
                                        onOnSelection={(event) =>
                                            actionHandler('benefitsDetailsOnPremium', event.detail)
                                        }
                                    >
                                        <ul>
                                            <li value={'Yes'}>Yes</li>
                                            <li value={'No'}>No</li>
                                        </ul>
                                    </OmRadioButtonGroup>
                                    <div slot="hint-text">
                                        <OmFormError message={benefitsDetailsOnPremium.error} />
                                    </div>
                                </>
                            )} */}

                            <div className="action-buttons">
                                {editQuoteDetails.id? <OmButton
                                    type="text"
                                    size="small"
                                    text="CANCEL"
                                    onClick={() => {
                                        dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: null }));
                                        dispatch(
                                            setQuoteDetailsStateValue({
                                                fieldType: 'editQuoteDetails',
                                                value: { id: null, category: null },
                                            })
                                        );
                                    }}
                                />:<OmButton
                                    type="text"
                                    size="small"
                                    text="Clear All"
                                    onClick={() =>  dispatch(setQuoteDrawerValue({ fieldType: 'coverType', value: KMF_COVER_CATEGORIES.BENIFITS }))}
                                />}
                                <OmButton
                                    type="primary"
                                    size="small"
                                    text={activePageIndex===2 ? 'SAVE': 'ADD TO QUOTE'}
                                    onClick={() => {
                                        dispatch(
                                            addToQuote({
                                                coverType: KMF_COVER_CATEGORIES.BENIFITS,
                                                relation: 'benifit',
                                            })
                                        );
                                    }}
                                />
                            </div>
                        </div>
                    </OmEfpAddCoverDrawer>
                </div>
            </OmSideDrawer>
        </>
    );
};

// const loadingText = (benefitsDrawer) => {
//     return (
//         <>
//             <BenefitsSideDrawerWrapper
//                 drawerIsOpen={benefitsDrawer}
//                 editCategory={EFP_COVER_CATEGORIES.DIRECT_FAMILY}
//             >
//                 <OmLoader loaderText={'Loading...'} isLoading={true} />
//             </BenefitsSideDrawerWrapper>
//         </>
//     );
// };

const BenifitsDrawer = () => {
    // if (applicationReferenceDataValid && quoteReferenceDataValid) {
    return <FormContent />;
    // }

    // return (
    //     <div>
    //         {loadingText(benefitsDrawer)}
    //     </div>
    // );
};

export default BenifitsDrawer;
